<template>
    <div>
        <vs-card class="content_mb_0 mb-0">
            <vs-row class="mb-8">
                <vs-col vs-lg="9" vs-sm="12" class="p-2">
                    <div class="lg:flex block">
                        <v-select style="width: 200px;"></v-select>
                        <vs-input class="lg:w-1/2 lg:ml-4" placeholder="Search" />
                    </div>
                </vs-col>
                <vs-col vs-lg="3" vs-sm="12" class="p-2">
                    <div class="flex justify-end items-center">
                        <a style="cursor: pointer;" class="inline-flex items-center">
                            <span style="font-size: 14px;" class="material-icons-outlined">file_upload</span>
                            <span class="pl-1">Upload CSV</span>
                        </a>
                    </div>
                </vs-col>
            </vs-row>

            <vs-row class="mt-8">
                <vs-col vs-lg="7" vs-sm="12" class="p-2">
                    <div class="flex flex-wrap">
                        <img style="width: 200px;" src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/Students+watching+webinar+on+computer.jpg" alt="course_image">
                        <div class="pl-2">
                            <h5 class="font-bold mb-4">Theory Group Lesson</h5>
                            <div class="flex flex-wrap items-center mb-4">
                                <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                                <span class="pl-2">Alias Danos</span>
                            </div>
                            <div class="course_status">
                                <span class="material-icons-outlined">location_city</span>
                                At School
                            </div>
                        </div>
                    </div>
                </vs-col>
                <vs-col vs-lg="5" vs-sm="12" class="p-2">
                    <div class="flex flex-col items-end">
                        <div class="flex flex-wrap flex-col pr-4">
                            <h5 class="font-bold mb-4">Schedule</h5>
                            <div class="flex flex-wrap">
                                <span class="material-icons-outlined">schedule</span>
                                <span class="pl-2">14:15 - 15:15</span>
                            </div>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
        </vs-card>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  }
}
</script>